// src/screens/LoginScreen.jsx
import React, { useState } from 'react';
import { loginWithGoogle, sendEmailLink } from '../services/authService';
import { toast } from '../components/UI';

export default function LoginScreen() {
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [mode, setMode] = useState('main');
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const handleGoogle = async () => {
    setGoogleLoading(true);
    try {
      await loginWithGoogle();
      // No se necesita hacer nada más — Supabase redirige al usuario
    } catch (err) {
      console.error('Google login error:', err);
      toast('No se pudo iniciar sesión con Google. Intenta de nuevo.', 'error');
      setGoogleLoading(false);
    }
  };

  const handleSendLink = async () => {
    if (!email.trim() || !email.includes('@')) {
      toast('Escribe un correo válido.', 'error');
      return;
    }
    setLoading(true);
    try {
      await sendEmailLink(email.trim());
      setEmailSent(true);
    } catch (err) {
      toast('No se pudo enviar el enlace. Verifica el correo.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>

      <div style={{
        flex: 1,
        background: 'linear-gradient(160deg, #0A1628 0%, #1A2E50 60%, #0F1E3A 100%)',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '40px 32px', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', width: 300, height: 300, borderRadius: '50%', border: '1px solid rgba(255,107,0,0.08)', top: -80, right: -80 }} />
        <div style={{ position: 'absolute', width: 200, height: 200, borderRadius: '50%', border: '1px solid rgba(255,107,0,0.06)', bottom: 40, left: -60 }} />

        <div style={{
          width: 90, height: 90,
          background: 'linear-gradient(135deg, var(--orange), var(--gold))',
          borderRadius: 24, display: 'flex', alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 16px 48px rgba(255,107,0,0.4)',
          marginBottom: 24,
        }}>
          <img src="/logo-principal.png" style={{ width: 60, height: 60, objectFit: 'contain' }} />
        </div>

        <h1 style={{
          fontFamily: 'var(--font-display)', fontSize: 38,
          letterSpacing: 3, color: '#FFFFFF',
          textAlign: 'center', lineHeight: 1, marginBottom: 6,
        }}>CLICK TRAVEL</h1>

        <p style={{ fontSize: 11, color: 'var(--orange)', letterSpacing: 4, fontWeight: 700, textAlign: 'center', marginBottom: 16 }}>
          AGENCY
        </p>

        <p style={{ fontSize: 14, color: 'var(--muted)', textAlign: 'center', lineHeight: 1.6 }}>
          Vuelos · Remesas · Recargas · Traducciones
        </p>
      </div>

      <div style={{
        background: 'var(--navy-light)',
        borderRadius: '28px 28px 0 0',
        padding: '32px 24px 44px',
        boxShadow: '0 -8px 32px rgba(0,0,0,0.3)',
      }}>

        {mode === 'main' && (
          <>
            <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--white)', marginBottom: 6 }}>
              ¡Bienvenido! 👋
            </h2>
            <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6, marginBottom: 28 }}>
              Envía remesas, recarga celulares y cotiza vuelos. Todo en un solo lugar.
            </p>

            <button
              onClick={handleGoogle}
              disabled={googleLoading}
              style={{
                width: '100%', background: 'white',
                border: 'none', borderRadius: 14,
                padding: '16px 20px',
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', gap: 12,
                cursor: googleLoading ? 'not-allowed' : 'pointer',
                opacity: googleLoading ? 0.75 : 1,
                boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
                transition: 'all 0.2s',
                marginBottom: 12,
              }}
            >
              {googleLoading ? (
                <span className="spinner" style={{ borderTopColor: '#4285F4', borderColor: 'rgba(66,133,244,0.25)' }} />
              ) : (
                <>
                  <svg width="22" height="22" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  <span style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>
                    Continuar con Google
                  </span>
                </>
              )}
            </button>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <div style={{ flex: 1, height: 1, background: 'var(--navy-border)' }} />
              <span style={{ fontSize: 12, color: 'var(--muted)' }}>o</span>
              <div style={{ flex: 1, height: 1, background: 'var(--navy-border)' }} />
            </div>

            <button
              onClick={() => setMode('email')}
              style={{
                width: '100%', background: 'transparent',
                border: '1.5px solid var(--navy-border)', borderRadius: 14,
                padding: '15px 20px',
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', gap: 12,
                cursor: 'pointer', color: 'var(--white)',
                fontSize: 15, fontWeight: 600,
              }}
            >
              ✉️ Continuar con correo
            </button>

            <p style={{ textAlign: 'center', fontSize: 11, color: 'var(--muted)', marginTop: 20, lineHeight: 1.7 }}>
              Al continuar aceptas nuestros{' '}
              <a href="/terminos.html" target="_blank" style={{ color: 'var(--orange)' }}>Términos y Condiciones</a>
              {' '}y la{' '}
              <a href="/terminos.html#privacidad" target="_blank" style={{ color: 'var(--orange)' }}>Política de Privacidad</a>
              {' '}(LGPD — Ley 13.709/2018)
            </p>
          </>
        )}

        {mode === 'email' && !emailSent && (
          <>
            <button onClick={() => setMode('main')} style={{ background: 'none', color: 'var(--muted)', fontSize: 13, marginBottom: 16, padding: 0 }}>
              ← Volver
            </button>
            <h2 style={{ fontSize: 20, fontWeight: 800, color: 'var(--white)', marginBottom: 8 }}>
              Acceso por correo
            </h2>
            <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6, marginBottom: 24 }}>
              Te enviamos un enlace mágico. Ábrelo desde tu celular y entras automáticamente.
            </p>

            <div style={{ marginBottom: 16 }}>
              <label>Tu correo electrónico</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="tucorreo@empresa.com"
                inputMode="email"
                autoFocus
                onKeyDown={e => e.key === 'Enter' && handleSendLink()}
              />
            </div>

            <button
              onClick={handleSendLink}
              disabled={loading}
              className="btn-primary"
            >
              {loading ? <span className="spinner" /> : 'Enviar enlace de acceso →'}
            </button>
          </>
        )}

        {mode === 'email' && emailSent && (
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <div style={{ fontSize: 52, marginBottom: 16 }}>📬</div>
            <h2 style={{ fontSize: 20, fontWeight: 800, color: 'var(--white)', marginBottom: 12 }}>
              ¡Revisa tu correo!
            </h2>
            <p style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7, marginBottom: 8 }}>
              Enviamos un enlace a
            </p>
            <p style={{ fontSize: 15, fontWeight: 700, color: 'var(--orange)', marginBottom: 20 }}>
              {email}
            </p>
            <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>
              Abre ese correo y toca el enlace para entrar. No necesitas contraseña.
            </p>
            <button onClick={() => { setMode('email'); setEmailSent(false); }}
              style={{ marginTop: 24, background: 'none', color: 'var(--muted)', fontSize: 13 }}>
              Usar otro correo
            </button>
          </div>
        )}

      </div>
    </div>
  );
}
